import React, { useEffect, useState } from 'react';
import { toCurrency } from '@app/utilities';
import { useGetAccountInterestRates } from '@app/sdk';
import { List } from 'semantic-ui-react';
import { Item } from '../../../shared/Item';
import { AccountInterestRateIllustration, AccountInterestRateValue } from '@app/models';
import { useAccountIdContext } from '../AccountIdContext';

export default function AccountRates() {
  const { accountId } = useAccountIdContext();

  const { data: accountInterestRates, isLoading } = useGetAccountInterestRates({ accountId });
  const [accountPurchaseRates, setAccountPurchaseRates] = useState<{
    purchaseRates: AccountInterestRateValue;
    illustration: AccountInterestRateIllustration;
  }>();

  useEffect(() => {
    if (!accountInterestRates) {
      setAccountPurchaseRates(null);
      return;
    }
    const illustration = accountInterestRates.illustration;
    const purchaseRates = accountInterestRates.rates.find(
      (r) => r.qualifications.SpendType == 'Purchase' && r.qualifications.FeeCategory == null
    ).values[0];
    setAccountPurchaseRates({ purchaseRates: purchaseRates, illustration: illustration });
  }, [accountInterestRates]);

  return (
    <div className="ui card">
      <div className="custom-card-header">Account Purchase Rates</div>
      <List className="content">
        {!isLoading ? (
          accountPurchaseRates && (
            <>
              <Item header={'Annual:'} description={accountPurchaseRates.purchaseRates.derivedGoToRate.air} />
              <Item header={'Monthly:'} description={accountPurchaseRates.purchaseRates.derivedGoToRate.mir} />
              <Item
                header={'Per Annum Variable:'}
                description={accountPurchaseRates.purchaseRates.derivedGoToRate.pa}
              />
              <Item header={'APR:'} description={accountPurchaseRates.illustration.apr} />
              <Item header={'TCC:'} description={toCurrency(accountPurchaseRates.illustration.tcc.value)} />
            </>
          )
        ) : (
          <div className="ui active centered inline loader" />
        )}
      </List>
    </div>
  );
}
